import axios from "axios";
import { API_URL } from "../../constants/constants";

// we need to pass the baseURL as an object
const API = axios.create({
  baseURL: API_URL,
});

export default API;
